import React from 'react'
import { Modal, Frame } from '@react95/core'
import { Heading, Text } from '@pancakeswap/uikit'
import { Mailnews15 } from '@react95/icons'
import { useTranslation } from 'contexts/Localization'
import { useTokenBalances } from 'state/wallet/hooks'
import { TokenAmount } from '@pancakeswap/sdk'
import tokens from 'config/constants/tokens'
import { useWeb3React } from '@web3-react/core'
import ConnectWalletButton from 'components/ConnectWalletButton'

const RewardsModal = ({ close, modalStyle, frameStyle }) => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const balances = useTokenBalances(account, [tokens.bnb, tokens.busd, tokens.windoge95])
  const windogeBalance: undefined | TokenAmount = balances?.[tokens.windoge95.address]
  return (
    <Modal
      defaultPosition={{ x: 12, y: 12 }}
      icon={<Mailnews15 />}
      title="Rewards"
      closeModal={close}
      width="90vw"
      height="90vh"
      style={modalStyle}
      buttons={[{ value: 'Ok', onClick: close }]}
    >
      <Frame style={frameStyle}>
        <Heading scale="xl" mb="16px" mt="16px">
          {t(`Holder Rewards:`)}
        </Heading>
        <Text fontSize="18px" mb="24px">
          {t(`By HODLing, you can earn Windoge95 tokens. Check your rewards below.`)}
        </Text>
        {!account && <ConnectWalletButton />}

        {account && !windogeBalance && (
          <>
            <Text fontSize="24px" fontWeight="bold">
              {t(`Loading balances...`)}
            </Text>
          </>
        )}

        {account && windogeBalance && (
          <>
            <Text fontSize="24px" fontWeight="bold">
              {t(`Your Windoge Balance:`)}
            </Text>
            <Text fontSize="24px" fontWeight="bold">
              {windogeBalance?.toFixed(2)} WNDG
            </Text>
          </>
        )}
        {windogeBalance && (
          <>
            <Text color="black" fontSize="20px" my="16px" textAlign="left">
              {t('You have earned X Windoge since your last purchase')}
            </Text>
            <Text color="black" fontSize="20px" textAlign="left">
              [ WINDOGE BALANCE ]
            </Text>
          </>
        )}
      </Frame>
    </Modal>
  )
}

export default RewardsModal
